export const iconFontAwesomeTextformattingCircleCheck = (
	<i className="fa-solid fa-circle-check"></i>
);
